export const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <g id="Filter" clipPath="url(#clip0_10089_2957)">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.833291 1.66504H-0.00170898V3.33504H0.833291H19.1666H20.0016V1.66504H19.1666H0.833291ZM3.33329 6.66504H2.49829V8.33504H3.33329H16.6666H17.5016V6.66504H16.6666H3.33329ZM4.99829 11.665H5.83329H14.1666H15.0016V13.335H14.1666H5.83329H4.99829V11.665ZM8.33329 16.5H7.33329V18.5H8.33329H11.6666H12.6666V16.5H11.6666H8.33329Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_10089_2957">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
